module.exports = { "default": require("core-js/library/fn/number/is-safe-integer"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/core-js/number/is-safe-integer.js
 ** module id = 271
 ** module chunks = 1
 **/